<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      <svg-icon
        icon-class="language-select"
        class="international-icon"
        :class="language === 'fr' ? 'language-fr' : 'language-en'"
        :style="{ color: language === 'fr' ? '#409EFF' : '#606266' }"
      />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language==='fr'" command="fr">
        <svg-icon icon-class="fr-flag" /> Français
      </el-dropdown-item>
      <el-dropdown-item :disabled="language==='en'" command="en">
        <svg-icon icon-class="en-flag" /> English
      </el-dropdown-item>
      <el-dropdown-item :disabled="language==='ar'" command="ar">
        <svg-icon icon-class="ar-flag" /> العربية
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Resource from '@/api/resource';
const localeResource = new Resource('locale');

export default {
  computed: {
    language() {
      return this.$store.getters.language;
    },
  },
  methods: {
    async handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch('app/setLanguage', lang);
      try {
        const { data } = await localeResource.store({ locale: lang });
        console.log(data);

        this.$message({
          message: 'Langue modifiée avec succès',
          type: 'success',
        });
      } catch (error) {
        console.error('Erreur lors de l\'enregistrement de la langue :', error);
        this.$message.error('Une erreur est survenue lors de la modification de la langue.');
      }
    },
  },
};
</script>

<style scoped>
.international-icon {
  font-size: 20px;
  cursor: pointer;
  vertical-align: -5px!important;
}
</style>

